import { render, staticRenderFns } from "./SubjectSelect.vue?vue&type=template&id=eb563d4e&"
import script from "./SubjectSelect.ts?vue&type=script&lang=ts&"
export * from "./SubjectSelect.ts?vue&type=script&lang=ts&"
import style0 from "./SubjectSelect.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports